(() => {
  const pageType = document.currentScript?.dataset?.pageType || '';

  const addHomeTrust = () => {
    if (pageType !== 'index' || document.querySelector('.gs-proof')) return;
    const styleNav = document.querySelector('.gs-style-nav');
    if (!styleNav) return;

    const reviews = [
      {
        name: 'Mimis',
        quote: 'Zunächst einmal muss ich sagen, dass ich die Auswahl an Kleidung wirklich toll finde. Die Qualität der Kleidungsstücke ist großartig und ich bin immer sehr zufrieden mit meinen Einkäufen. 🌷'
      },
      {
        name: 'Arine K.',
        quote: 'Die Lives sind ein Highlight! Ich habe schon mehrmals bestellt und war immer sehr zufrieden. Es gibt viele Tipps zum Tragen und die Größenangabe ist auf den Punkt. ❤️'
      },
      {
        name: 'Simone W.',
        quote: 'Das gesamte Team vom Goldstück ist immer so bemüht und versucht wirklich jeden Wunsch zu erfüllen. Auch die Beratung übers Telefon ist sensationell. Deshalb für mich mein Lieblingsladen – und das bereits seit etlichen Jahren!'
      }
    ];

    const proof = document.createElement('section');
    proof.className = 'gs-proof';
    proof.innerHTML = `<div class="gs-proof__inner">
      <div class="gs-proof__header">
        <div><p class="gs-proof__eyebrow">Goldstück Community</p><h2 class="gs-proof__title">Von euch geliebt. ♡</h2></div>
        <p class="gs-proof__intro">Echte Stimmen aus unserer Community – von Kundinnen, die online bestellen, unsere Lives verfolgen und uns seit Jahren begleiten.</p>
      </div>
      <div class="gs-proof__grid">${reviews.map((review) => `<article class="gs-proof-card"><div><div class="gs-proof-card__stars" aria-label="5 von 5 Sternen">★★★★★</div><p class="gs-proof-card__quote">„${review.quote}“</p></div><footer class="gs-proof-card__footer"><span class="gs-proof-card__name">${review.name}</span><span>Verifizierte Bewertung</span></footer></article>`).join('')}</div>
    </div>`;

    const brands = [
      ['American Vintage','/collections/american-vintage'],
      ['Alix the Label','/collections/alix-the-label'],
      ['SABBI','/collections/sabbi'],
      ['PNTS','/collections/pnts'],
      ['Legami','/collections/legami-1'],
      ['RICE','/collections/rice']
    ];

    const brandSection = document.createElement('section');
    brandSection.className = 'gs-brands-edit';
    brandSection.innerHTML = `<div class="gs-brands-edit__inner">
      <div class="gs-brands-edit__header">
        <div><p class="gs-brands-edit__eyebrow">Unsere Auswahl</p><h2 class="gs-brands-edit__title">Marken, die wir lieben.</h2></div>
        <p class="gs-brands-edit__intro">Labels, die wir für dich auswählen – von zeitlosen Favoriten bis zu besonderen Neuentdeckungen. <a href="/pages/marken">Alle Marken A–Z</a></p>
      </div>
      <div class="gs-brands-edit__grid">${brands.map(([name,url]) => `<a class="gs-brand-link" href="${url}"><span class="gs-brand-link__name">${name}</span><span class="gs-brand-link__arrow" aria-hidden="true">↗</span></a>`).join('')}</div>
    </div>`;

    styleNav.insertAdjacentElement('afterend', proof);
    proof.insertAdjacentElement('afterend', brandSection);
  };

  const initMobileStickyBuy = () => {
    if (pageType !== 'product' || document.querySelector('.gs-mobile-sticky-buy')) return;

    const nativeButton = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"] buy-buttons button[type="submit"]');
    if (!nativeButton) return;

    const title = document.querySelector('.product-info__block-item[data-block-type="title"]')?.textContent?.trim() || 'Dein Goldstück';
    const price = document.querySelector('.product-info__block-item[data-block-type="price"] .price-list, .product-info__block-item[data-block-type="price"]')?.textContent?.replace(/\s+/g,' ')?.trim() || '';

    const bar = document.createElement('div');
    bar.className = 'gs-mobile-sticky-buy';
    bar.setAttribute('aria-hidden','true');
    bar.innerHTML = `<div class="gs-mobile-sticky-buy__copy"><span class="gs-mobile-sticky-buy__title"></span><span class="gs-mobile-sticky-buy__price"></span></div><button class="gs-mobile-sticky-buy__button" type="button">In den Warenkorb</button>`;
    bar.querySelector('.gs-mobile-sticky-buy__title').textContent = title;
    bar.querySelector('.gs-mobile-sticky-buy__price').textContent = price;

    const stickyButton = bar.querySelector('.gs-mobile-sticky-buy__button');
    const sync = () => {
      stickyButton.disabled = nativeButton.disabled;
      stickyButton.textContent = nativeButton.disabled ? (nativeButton.textContent.trim() || 'Nicht verfügbar') : 'In den Warenkorb';
    };
    sync();

    stickyButton.addEventListener('click', () => {
      if (!nativeButton.disabled) nativeButton.click();
    });

    new MutationObserver(sync).observe(nativeButton,{attributes:true,childList:true,subtree:true});
    document.body.appendChild(bar);

    const observer = new IntersectionObserver(([entry]) => {
      const mobile = window.matchMedia('(max-width: 699px)').matches;
      const show = mobile && !entry.isIntersecting;
      bar.classList.toggle('is-visible',show);
      bar.setAttribute('aria-hidden',show ? 'false' : 'true');
    },{threshold:.05});
    observer.observe(nativeButton);
  };

  const init = () => {
    addHomeTrust();
    initMobileStickyBuy();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
